<template>
  <div class="layout">
    <nav class="navigation-menu">
      <app-navbar />
    </nav>
    <app-sidebar />
    <div class="main-content" :class="{ 'nav-collapsed': isSideNavCollapsed }">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import AppSidebar from "./components/Sidebar/index";
import AppNavbar from "./components/Navbar";
export default {
  components: {
    AppSidebar,
    AppNavbar,
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    isSideNavCollapsed() {
      return this.$store.getters.isSideNavCollapsed;
    },
  },
  isIdle(newval) {
      if (newval == true) {
        localStorage.clear();
        this.$router.push({
          name: "Home",
        });
      }
    },
};
</script>

<style>
.main-content {
  min-height: calc(100vh - 4rem);
  background: #edf2ef;
  margin-left: 20vw;
  margin-top: 4rem;
  transition: all ease 0.3s;
  padding: 1.5rem 1rem;
}
.nav-collapsed {
  margin-left: 3vw;
}
@media screen and (max-width: 1024px) {
  .main-content {
    margin-left: 0;
    padding: 1rem 0.5rem;
  }
  .nav-collapsed {
    margin-left: 6.6vw !important;
  }
}
</style>
